import { api } from './api';

export interface Notificacion {
  id: number;
  tenantId: number;
  usuarioId?: number;
  tipo: 'info' | 'warning' | 'error' | 'success' | 'system';
  categoria: 'inventario' | 'orden' | 'transferencia' | 'sesion_caja' | 'cliente' | 'sistema' | 'otro';
  titulo: string;
  mensaje: string;
  data?: any;
  url?: string;
  leida: boolean;
  leidaEn?: string;
  expiraEn?: string;
  createdAt: string;
  updatedAt: string;
}

export interface NotificacionesResponse {
  notificaciones: Notificacion[];
  noLeidas: number;
}

export const notificacionService = {
  getAll: async (leida?: boolean, categoria?: string, limit?: number): Promise<{ data: NotificacionesResponse }> => {
    const params = new URLSearchParams();
    if (leida !== undefined) params.append('leida', leida.toString());
    if (categoria) params.append('categoria', categoria);
    if (limit) params.append('limit', limit.toString());
    
    const response = await api.get<{ data: NotificacionesResponse }>(`/notificaciones?${params.toString()}`);
    return response.data;
  },

  marcarComoLeida: async (id: number): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>(`/notificaciones/${id}/marcar-leida`);
    return response.data;
  },

  marcarTodasComoLeidas: async (): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>('/notificaciones/marcar-todas-leidas');
    return response.data;
  },

  eliminar: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/notificaciones/${id}`);
    return response.data;
  }
};

